import { map } from 'lodash/fp';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AccountType } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedSectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { isBillingCustomerOrCompany } from '../../selectors';
import { AccountBillList } from './AccountBillList';

interface CurrentSectionProps {
    accountIds: string[];
    billId?: string;
    scope: string;
}

export const CurrentSection: FC<CurrentSectionProps> = ({ accountIds, billId, scope }) => {
    const billingOwner = useSelector((state: ApplicationState) => isBillingCustomerOrCompany(state, { scope }));
    const isBillingOwnerCustomer = billingOwner === AccountType.Customer;

    return (
        <Stack spacing="100" vertical>
            <LocalizedSectionTitle
                textKey={isBillingOwnerCustomer ? TextKey.CurrentCustomer : TextKey.CurrentCompany}
            />
            {map(
                (accountId) => (
                    <AccountBillList
                        key={accountId}
                        accountId={accountId}
                        billId={billId}
                        isCompany={!isBillingOwnerCustomer}
                        isCurrentAccount
                    />
                ),
                accountIds
            )}
        </Stack>
    );
};
